import * as React from 'react';
import { useDropzone } from 'react-dropzone';
import { Ref } from 'react-hook-form';

import './index.scss';

interface IProps {
    register: Ref;
}

export const FileUpload: React.SFC<IProps> = ({ register }) => {
    const [selectedFile, handleFileChange] = React.useState<File>();
    const onDrop = React.useCallback(
        (files: File[]) => {
            handleFileChange(files[0]);
        },
        [],
    );
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: false,
    });

    return (
        <div className="dropZone">
            <label htmlFor="file" {...getRootProps()}>
                <svg id="Group_322" data-name="Group 322" xmlns="http://www.w3.org/2000/svg" width="30.037" height="30" viewBox="0 0 30.037 30">
                    <line id="Line_46" data-name="Line 46" y2="30" transform="translate(15.019)" fill="none" stroke="#272727" stroke-width="1" />
                    <line id="Line_47" data-name="Line 47" y2="30.037" transform="translate(30.037 15.593) rotate(90)" fill="none" stroke="#272727" stroke-width="1" />
                </svg>
            </label>
            <span>
                Browse for files
            </span>
            <h4>{selectedFile && selectedFile.name}</h4>
            <input
                {...getInputProps()}
                style={{ display: 'none' }}
                type="file"
                id="file"
                name="file"
                accept=".pdf"
                ref={register}
            />
        </div>
    );
};
